<section
  class="block relative w-full z-[899]"
  #headerNav
  (mouseleave)="openCloseMenu()"
  >
  @if (navigationSub) {
    <div
      class="hidden relative py-1 pr-[70px] pl-[55px] xl:flex justify-end bg-mat-ef-revolution-supergrey-100 text-[13px] font-efSans"
      >
      <div class="flex text-[13px] text-mat-ef-gray-one-200">
        <div class="contact-phones" [innerHTML]="navigationSub.context"></div>
        @for (page of navigationSub.pages; track page) {
          <a
            class="ml-6 text-mat-ef-gray-one-200 no-underline"
            [href]="getHref(page)"
            >
            {{ page.content.text }}
          </a>
        }
      </div>
    </div>
  }
  <div
    class="bg-white flex justify-between py-2.5 px-5 xl:px-[55px] items-center"
    >
    @if (screenSize === 'mobile') {
      <customer-portal-app-navbar-back
      ></customer-portal-app-navbar-back>
    }

    @if (header && header.header.logo) {
      <a
        class="flex items-center logo cursor-pointer min-w-fit"
        [href]="efWebsiteUrl"
        target="_blank"
        >
        <mat-icon
          svgIcon="ef-logo-icon"
          class="w-10 h-10 md:w-[52px] md:h-[52px] text-mat-ef-primary-500"
        ></mat-icon>
        <div class="text-sm pl-3 lg:text-base flex gap-1">
          <span class="font-efSans text-mat-ef-primary-500 font-bold">
            Emil Frey
          </span>
          <span class="font-efSans text-mat-ef-primary-500">
            <!-- prettier-ignore -->
            {{ country | translate:{ _key: 'customerPortal.customer-portal.country.' + country , _tags: 'customer-portal, notranslate'} }}
          </span>
        </div>
      </a>
    }
    @if (header) {
      <div
        class="hidden xl:flex -translate-x-1/2 max-w-[1050px] absolute left-1/2 min-w-[620px] w-[620px] items-center"
        >
        <div class="flex items-center w-full max-w-[620px]">
          @for (item of header.navigationMain; track item; let i = $index) {
            <div
              class="flex wrap justify-evenly w-full cursor-pointer"
              >
              @if (item.children && item.children.length > 0) {
                <a
                  class="flex uppercase font-efSans font-bold text-sm text-mat-ef-gray-one-300 items-center no-underline hover:underline"
                  (mouseenter)="openCloseMenu(i)"
            (click)="
              openCloseMenu(i); sendGTMNavigationData(item.title, 'Textlink')
            "
                  [ngClass]="activeStyle(i)"
                  target="_blank"
                  >
                  <div class="w-full relative">
                    <div class="w-full pr-[25px] whitespace-nowrap z-20">
                      {{ item.title }}
                    </div>
                    <div class="absolute right-0 top-0 -z-10">
                      <mat-icon
                        class="max-h-5"
                  [svgIcon]="
                    (toggleMenu0 && i === 0) ||
                    (toggleMenu2 && i === 2) ||
                    (toggleMenu3 && i === 3)
                      ? 'expand_less'
                      : 'expand_more'
                  "
                        >
                      </mat-icon>
                    </div>
                  </div>
                </a>
              }
              @if (item.children && item.children.length < 1) {
                <a
                  class="flex uppercase font-efSans font-bold text-sm text-mat-ef-gray-one-300 items-center no-underline hover:underline"
                  [href]="baseUrl + item.link"
            (click)="
              openCloseMenu(i); sendGTMNavigationData(item.title, 'Textlink')
            "
                  target="_blank"
                  >
                  {{ item.title }}
                </a>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (toggleMenu0) {
      <div
        id="menu0"
        class="absolute min-w-full top-[100px] left-0 bg-white z-50 shadow-none"
        [@inOutAnimation]
        >
        <div class="grid px-[207px] pt-[132px] pb-[76px] mb-[76px] grid-cols-3">
          @if (header && header.navigationMain) {
            <div
              class="font-efSans text-lg font-semibold leading-6 text-left tracking-normal col-span-1"
              >
              <h6 class="pt-6 text-xl font-bold mb-6 text-mat-ef-revolution-grey-two-500">
                {{ header.navigationMain[0].title }}
              </h6>
              @for (link of header.navigationMain[0].children; track link) {
                <div>
                  @if (link.link !== '/') {
                    <a
                      class="links no-underline text-mat-ef-primary-500 inline-flex items-center mb-6"
              [href]="
                !link.link.startsWith('http') ? baseUrl + link.link : link.link
              "
                      (click)="sendGTMNavigationData(link.title, 'Textlink')"
                      target="_blank"
                      >
                      <div class="h-6 pr-4">
                        <mat-icon
                          class="bg-mat-ef-primary-500 text-white rounded-full"
                          svgIcon="arrow_right"
                        ></mat-icon>
                      </div>
                      {{ link.title }}
                    </a>
                  }
                </div>
              }
            </div>
          }
          <div class="col-span-2">
            @if (
              offerFirstMenu &&
              offerFirstMenu.content.actions &&
              offerFirstMenu.content.actions[0]
              ) {
              <a
            [href]="
              baseUrl + getLinkUrl(offerFirstMenu.content.actions[0].content.link)
            "
                target="_blank"
                >
                @if (offerFirstMenu) {
                  <div
                    class="max-h-[288px] bg-no-repeat bg-cover h-full bg-center rounded-lg flex relative"
              [style.background-image]="
                'url(' + offerFirstMenu.content.imageXl[0][0].publicUrl + ')'
              "
                    >
                    <div class="offer-brands"></div>
                    <div class="absolute bottom-8 left-8">
                      <p class="text-white font-bold text-sm mb-0 tracking-widest">
                        {{ offerFirstMenu.content.availability }}
                      </p>
                      <h4 class="text-white my-0 text-2xl">
                        {{ offerFirstMenu.content.headline }}
                      </h4>
                      <p
                        class="text-white text-sm my-0 uppercase tracking-widest font-efSans font-bold leading-5"
                        >
                        {{ offerFirstMenu.content.subline }}
                      </p>
                    </div>
                    @if (offerFirstMenu.content.ctaboxPrice) {
                      <div
                        class="absolute right-8 bottom-8 rounded-lg h-[160px] w-[160px] bg-mat-ef-red-secondary-500"
                        >
                        <div
                          class="flex flex-col justify-between min-w-[130px] h-[130px] overflow-hidden p-4 w-min"
                          >
                          <p
                            class="flex flex-col justify-between text-base font-efSans m-0 h-full pb-1 text-white"
                            >
                            <span class="hidden xl:block">{{
                              offerFirstMenu.content.availability
                            }}</span>
                            <span class="block xl:hidden"></span>
                            <span class="offer-text-ab">
                              <T
                              str="from"
                              key="customerPortal.customer-portal.header.offer-text.ab"
                              tags="customer-portal, 3.1"
                              ></T
                            ></span>
                          </p>
                          <h5 class="text-white m-0 leading-none font-bold text-3xl">
                            {{
                            offerFirstMenu.content.ctaboxPrice
                            | currency: currency:true:'1.0-0':currencyLocale
                            }}
                            <span class="text-base font-efSans"
                              >/{{ offerFirstMenu.content.ctaboxTime }}</span
                              >
                            </h5>
                          </div>
                        </div>
                      }
                      @if (
                        offerFirstMenu.content.offerbrand &&
                        offerFirstMenu.content.offerbrand.logo
                        ) {
                        <div
                          class="header-brands h-[26px] min-w-[26px] absolute right-8 top-8"
                          >
                          <img
                            alt="logo"
                            [src]="offerFirstMenu.content.offerbrand.logo[0].publicUrl"
                            />
                        </div>
                      }
                    </div>
                  }
                </a>
              }
              @if (header.navigationMain && header.navigationMain[0] && header.navigationMain[0].dropdown) {
                <div class="flex gap-8">
                  @if (topicsFirstMenu && topicsFirstMenu.cards && topicsFirstMenu.cards.length > 0) {
                    <div class="topics flex-1">
                      <div class="header">
                        <h6
                          class="pt-6 text-2xl font-bold my-0 text-mat-ef-revolution-grey-two-500"
                          >
                          {{ topicsFirstMenu.headline }}
                        </h6>
                      </div>
                      <div class="cards">
                        <div class="flex flex-col w-full">
                          @for (card of topicsFirstMenu.cards; track card) {
                            <div
                              class="flex items-center pt-5"
                              >
                              @if (card && card.content.action && card.content.action[0]) {
                                <a
                                  class="text-mat-ef-revolution-grey-two-500 no-underline bg-inerhit font-efSans text-sm font-semibold"
                                  [href]="baseUrl + card.content.action[0].content.link"
                                  target="_blank"
                                  >
                                  <img
                                    [alt]="card.content.header.text"
                                    class="max-w-[100px] max-h-[100px] rounded-lg my-0 ml-0 mr-6"
                                    [src]="card.content.image.publicUrl"
                                  /></a>
                                }
                                <div
                                  class="font-efSans font-semibold text-mat-ef-revolution-grey-two-500"
                                  >
                                @if (card && card.content.action && card.content.action[0]) {
                                  <a
                                    [href]="baseUrl + card.content.action[0].content.link"
                                    target="_blank"
                                    >
                                    <span>{{ card.content.header.text }}</span>
                                  </a>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @if (header.navigationMain[0].dropdown.searchlinks && header.navigationMain[0].dropdown.searchlinks.actions && header.navigationMain[0].dropdown.searchlinks.actions.length > 0) {
                    <div class="searchlinks flex-1 font-efSans text-lg leading-6 text-left tracking-normal font-semibold">
                      <h6 class="pt-6 text-xl font-bold mb-6 text-mat-ef-revolution-grey-two-500">
                        {{ header.navigationMain[0].dropdown.searchlinks.headline }}
                      </h6>
                      <div class="flex flex-col">
                        @for (action of header.navigationMain[0].dropdown.searchlinks.actions; track action) {
                          <a
                            [href]="baseUrl + getLinkUrl(action.content.link)"
                            class="links no-underline text-mat-ef-primary-500 inline-flex items-center mb-6"
                            target="_blank"
                            >
                            <div class="h-6 pr-4 border-black">
                              <mat-icon
                                class="bg-mat-ef-primary-500 text-white rounded-full"
                                svgIcon="arrow_right"
                              ></mat-icon>
                            </div>
                            {{ action.content.text }}
                          </a>
                        }
                      </div>
                    </div>
                  }
                  @if (header.navigationMain[0].dropdown.brandlinks && header.navigationMain[0].dropdown.brandlinks.brands && header.navigationMain[0].dropdown.brandlinks.brands.length > 0) {
                    <div class="brandlinks flex-1 font-efSans text-lg leading-6 text-left tracking-normal font-semibold">
                      <h6 class="pt-6 text-xl font-bold mb-6 text-mat-ef-revolution-grey-two-500">
                        {{ header.navigationMain[0].dropdown.brandlinks.headline }}
                      </h6>
                      <div class="brandsContainer grid grid-cols-[50px_50px_50px_50px] grid-rows-[64px_64px_64px] gap-x-[12px] gap-y-[8px]">
                        @for (brand of header.navigationMain[0].dropdown.brandlinks.brands; track brand) {
                          <a
                            [href]="baseUrl + '/auto-kaufen/' + brand.name"
                            class="flex flex-col items-center text-mat-ef-revolution-grey-two-500 no-underline cursor-pointer"
                            target="_blank"
                            >
                            <span class="brand-logo flex items-center justify-center w-[50px] h-[50px] bg-gray-200/50 rounded">
                              @if (brand.logocustomsized && brand.logocustomsized[0]) {
                                <img
                                  [src]="brand.logocustomsized[0].publicUrl"
                                  [alt]="brand.name"
                                  class="max-h-[26px] max-w-full object-contain"
                                  />
                              }
                            </span>
                            <span class="brand-name font-efSans font-semibold text-[9px] leading-[14px] cursor-pointer">{{ brand.name }}</span>
                          </a>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (toggleMenu2) {
        <div
          id="menu2"
          class="absolute min-w-full top-[100px] left-0 bg-white z-50 shadow-none"
          [@inOutAnimation]
          >
          <div class="grid px-[207px] pt-[132px] pb-[76px] mb-[76px] grid-cols-3">
            @if (header && header.navigationMain && header.navigationMain[2]) {
              <div
                class="font-efSans text-lg font-semibold leading-6 text-left tracking-normal col-span-1"
                >
                <p
                  class="font-canelablack-primary text-4xl font-bold tracking-normal text-left p-0 mb-9 leading-normal"
                  >
                  {{ header.navigationMain[2].title }}
                </p>
                @for (link of header.navigationMain[2].children; track link) {
                  <div>
                    @if (link.link !== '/') {
                      <a
                        class="links text-mat-ef-primary-500 inline-flex items-center mb-6"
              [href]="
                !link.link.startsWith('http') ? baseUrl + link.link : link.link
              "
                        target="_blank"
                        >
                        <div class="h-6 pr-4">
                          <mat-icon
                            class="bg-mat-ef-primary-500 text-white rounded-full"
                            svgIcon="arrow_right"
                          ></mat-icon>
                        </div>
                        {{ link.title }}
                      </a>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (toggleMenu3) {
        <div
          id="menu3"
          class="absolute min-w-full top-[100px] left-0 bg-white z-50 shadow-none"
          [@inOutAnimation]
          >
          <div class="grid px-[207px] pt-[132px] pb-[76px] mb-[76px] grid-cols-3">
            @if (header && header.navigationMain && header.navigationMain[2]) {
              <div
                class="font-efSans text-lg font-semibold leading-6 text-left tracking-normal col-span-1"
                >
                <h6 class="pt-6 text-xl font-bold mb-6 text-mat-ef-revolution-grey-two-500">
                  {{ header.navigationMain[3].title }}
                </h6>
                @for (link of header.navigationMain[3].children; track link) {
                  <div>
                    @if (link.link !== '/') {
                      <a
                        class="links text-mat-ef-primary-500 inline-flex items-center mb-6"
              [href]="
                !link.link.startsWith('http') ? baseUrl + link.link : link.link
              "
                        target="_blank"
                        >
                        <div class="h-6 pr-4">
                          <mat-icon
                            class="bg-mat-ef-primary-500 text-white rounded-full"
                            svgIcon="arrow_right"
                          ></mat-icon>
                        </div>
                        {{ link.title }}
                      </a>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }

      <div class="relative flex gap-4 items-center">
        <customer-portal-app-navbar-right
          [header]="header"
        ></customer-portal-app-navbar-right>
      </div>
    </div>
  </section>
